import UploadOfferView from "./UploadOfferView";

export default UploadOfferView;
